import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const StudentEvents = () => {
  const routes = all_routes;
  const [activeTab, setActiveTab] = useState("upcoming");

  // Mock events data
  const eventsData = {
    upcoming: [
      {
        id: 1,
        title: "Science Fair 2024",
        date: "2024-08-25",
        time: "9:00 AM - 4:00 PM",
        location: "Main Auditorium",
        type: "academic",
        description:
          "Annual science fair with student projects and demonstrations",
        status: "upcoming",
      },
      {
        id: 2,
        title: "Math Olympiad",
        date: "2024-08-28",
        time: "10:00 AM - 12:00 PM",
        location: "Room 301",
        type: "competition",
        description: "Mathematics competition for grade 10-12 students",
        status: "upcoming",
      },
      {
        id: 3,
        title: "Parent-Teacher Meeting",
        date: "2024-09-02",
        time: "2:00 PM - 5:00 PM",
        location: "Classroom",
        type: "meeting",
        description: "Quarterly parent-teacher discussion",
        status: "upcoming",
      },
      {
        id: 4,
        title: "Sports Day",
        date: "2024-09-10",
        time: "8:00 AM - 3:00 PM",
        location: "Sports Ground",
        type: "sports",
        description: "Annual sports competition and activities",
        status: "upcoming",
      },
    ],
    past: [
      {
        id: 5,
        title: "Welcome Assembly",
        date: "2024-08-15",
        time: "9:00 AM - 10:00 AM",
        location: "Main Hall",
        type: "assembly",
        description: "New academic year welcome ceremony",
        status: "completed",
      },
      {
        id: 6,
        title: "Career Guidance Workshop",
        date: "2024-08-10",
        time: "1:00 PM - 3:00 PM",
        location: "Conference Room",
        type: "workshop",
        description: "Career counseling and guidance session",
        status: "completed",
      },
    ],
  };

  const getEventTypeColor = (type: string) => {
    switch (type) {
      case "academic":
        return "bg-primary";
      case "competition":
        return "bg-warning";
      case "meeting":
        return "bg-info";
      case "sports":
        return "bg-success";
      case "assembly":
        return "bg-secondary";
      case "workshop":
        return "bg-danger";
      default:
        return "bg-primary";
    }
  };

  const getEventTypeIcon = (type: string) => {
    switch (type) {
      case "academic":
        return "ti-book";
      case "competition":
        return "ti-trophy";
      case "meeting":
        return "ti-users";
      case "sports":
        return "ti-ball-football";
      case "assembly":
        return "ti-microphone-2";
      case "workshop":
        return "ti-tools";
      default:
        return "ti-calendar-event";
    }
  };

  const renderEventCard = (event: any) => {
    return (
      <div key={event.id} className="card mb-3">
        <div className="card-body">
          <div className="d-flex align-items-start">
            <div
              className={`avatar avatar-sm me-3 ${getEventTypeColor(
                event.type
              )}`}
            >
              <i
                className={`ti ${getEventTypeIcon(event.type)} text-white`}
              ></i>
            </div>
            <div className="flex-fill">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <h6 className="mb-0">{event.title}</h6>
                <span
                  className={`badge ${
                    event.status === "upcoming" ? "bg-success" : "bg-secondary"
                  }`}
                >
                  {event.status === "upcoming" ? "Upcoming" : "Completed"}
                </span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <span className="badge bg-light text-dark me-2">
                  <i className="ti ti-calendar me-1"></i>
                  {event.date}
                </span>
                <span className="badge bg-light text-dark me-2">
                  <i className="ti ti-clock me-1"></i>
                  {event.time}
                </span>
                <span className="badge bg-light text-dark">
                  <i className="ti ti-map-pin me-1"></i>
                  {event.location}
                </span>
              </div>
              <p className="text-muted mb-0 small">{event.description}</p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.studentDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Events Calendar</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="card bg-success">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="text-white">
                      <h3>Events Calendar</h3>
                      <p>Stay updated with school events and activities</p>
                    </div>
                    <div className="avatar avatar-lg">
                      <i className="ti ti-calendar-event text-white fs-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Summary Cards */}
          <div className="row">
            <div className="col-sm-6 col-lg-3">
              <div className="card">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-primary-transparent mb-3">
                    <i className="ti ti-calendar-plus fs-2 text-primary"></i>
                  </div>
                  <h4 className="text-primary">{eventsData.upcoming.length}</h4>
                  <p className="mb-0">Upcoming Events</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-3">
              <div className="card">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-warning-transparent mb-3">
                    <i className="ti ti-trophy fs-2 text-warning"></i>
                  </div>
                  <h4 className="text-warning">
                    {
                      eventsData.upcoming.filter(
                        (e) => e.type === "competition"
                      ).length
                    }
                  </h4>
                  <p className="mb-0">Competitions</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-3">
              <div className="card">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-success-transparent mb-3">
                    <i className="ti ti-ball-football fs-2 text-success"></i>
                  </div>
                  <h4 className="text-success">
                    {
                      eventsData.upcoming.filter((e) => e.type === "sports")
                        .length
                    }
                  </h4>
                  <p className="mb-0">Sports Events</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-3">
              <div className="card">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-info-transparent mb-3">
                    <i className="ti ti-book fs-2 text-info"></i>
                  </div>
                  <h4 className="text-info">
                    {
                      eventsData.upcoming.filter((e) => e.type === "academic")
                        .length
                    }
                  </h4>
                  <p className="mb-0">Academic Events</p>
                </div>
              </div>
            </div>
          </div>

          {/* Events Content */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <ul className="nav nav-tabs card-header-tabs">
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTab === "upcoming" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("upcoming")}
                      >
                        <i className="ti ti-calendar-plus me-2"></i>
                        Upcoming Events ({eventsData.upcoming.length})
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTab === "past" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("past")}
                      >
                        <i className="ti ti-calendar-check me-2"></i>
                        Past Events ({eventsData.past.length})
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="card-body">
                  {activeTab === "upcoming" && (
                    <div>
                      {eventsData.upcoming.length > 0 ? (
                        eventsData.upcoming.map((event) =>
                          renderEventCard(event)
                        )
                      ) : (
                        <div className="text-center py-4">
                          <div className="avatar avatar-lg bg-light mb-3">
                            <i className="ti ti-calendar-off fs-2 text-muted"></i>
                          </div>
                          <h5>No upcoming events</h5>
                          <p className="text-muted">
                            Check back later for new events and activities.
                          </p>
                        </div>
                      )}
                    </div>
                  )}

                  {activeTab === "past" && (
                    <div>
                      {eventsData.past.length > 0 ? (
                        eventsData.past.map((event) => renderEventCard(event))
                      ) : (
                        <div className="text-center py-4">
                          <div className="avatar avatar-lg bg-light mb-3">
                            <i className="ti ti-calendar-x fs-2 text-muted"></i>
                          </div>
                          <h5>No past events</h5>
                          <p className="text-muted">
                            Past events will appear here.
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentEvents;
